import { showToast } from "../components/Toast";

export const handleError = (error, customMessage = "Ocorreu um erro inesperado.") => {
    let errorMessage = customMessage;

    if (error?.response?.status) {
        // Mapeamento de status HTTP para mensagens amigáveis
        const statusMessages = {
            400: "Requisição inválida. Verifique os dados e tente novamente.",
            401: "Sessão expirada. Faça login novamente.",
            403: "Você não tem permissão para realizar essa ação.",
            404: "Recurso não encontrado.",
            422: "Estoque insuficiente para concluir o pedido.",
            500: "Erro interno no servidor. Tente novamente mais tarde.",
        };

        errorMessage = statusMessages[error.response.status] || "Ocorreu um erro ao processar a solicitação.";
    } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
    } else if (error instanceof Error) {
        errorMessage = error.message;
    } else if (typeof error === "string") {
        errorMessage = error;
    }

    showToast("Erro!", "error", 5000, errorMessage);
    if (error?.response?.status === 401) {
        window.location.href = '/login';
    }
};